import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const getInitialLanguage = () => {
    // Check URL parameter first
    const params = new URLSearchParams(window.location.search);
    const urlLang = params.get('lang');
    if (urlLang && ['en', 'zh'].includes(urlLang)) {
      return urlLang;
    }
    // Then check localStorage
    const savedLanguage = localStorage.getItem('pumpCalculatorLanguage');
    return savedLanguage || 'en';
  };

  const [language, setLanguage] = useState(getInitialLanguage);

  const [t, setT] = useState(translations[language]);

  useEffect(() => {
    setT(translations[language]);
    localStorage.setItem('pumpCalculatorLanguage', language);
  }, [language]);

  const switchLanguage = (lang) => {
    setLanguage(lang);
  };

  const value = {
    language,
    t,
    switchLanguage,
    isEnglish: language === 'en',
    isChinese: language === 'zh'
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};
